import { Box, Typography } from "@material-ui/core";
import _get from "lodash/get";
import { useMemo } from "react";
import { DialogApplyButton, DialogLogo, Spinner } from "components";
import { useLendingTokenMutations } from "hooks/mutation";
import { useBorrowContext } from "context/contracts/BorrowContext";
import { useStyles } from "../RepayModal/useStyles";

const ApprovalModal = ({ logoLendingToken, lendingTokenAddress, lendingTokenName }) => {
  const context = useBorrowContext();
  const classes = useStyles();
  const { isLoading, approve } = useLendingTokenMutations();

  const fTokenRate = useMemo(
    () => _get(context, ["fTokenRate", lendingTokenAddress], {}),
    [context, lendingTokenAddress]
  );

  const handleEnable = () => {
    approve({ address: lendingTokenAddress, ftoken: _get(fTokenRate, "ftoken") });
  };

  return (
    <>
      <DialogLogo logoUrl={logoLendingToken} name={lendingTokenName} />
      {isLoading && <Spinner position="absolute" color="success" />}
      <Box pt={5} p={0} className={classes.rootContainer}>
        <Box m={3}>
          <Typography color="primary" align="center">
            To use {lendingTokenName}, you need to enable it first.
          </Typography>
        </Box>
        <Box>
          <DialogApplyButton onClick={handleEnable}>Enable</DialogApplyButton>
        </Box>
      </Box>
    </>
  );
};

export default ApprovalModal;
